import Vue from "vue";
import { isEmptyObject } from "@utils/types";

export default {
  namespaced: true,
  state: () => ({
    fetching: false,
    available: false,
    data: {}
  }),
  getters: {
    data: state => (isEmptyObject(state.data) ? false : state.data)
  },
  mutations: {
    fetching(state, payload) {
      state.fetching = payload;
    },
    available(state, payload) {
      state.available = payload;
    }
  },
  actions: {
    addData({ state }, { key, value }) {
      Vue.set(state.data, key, value);
    }
  }
};
